export const PACKAGE_VERSION = require('../../package.json').version
export const CLIENT_KEY = 'aaaaa'
export const buildFcmTokenHeader = () => {
  return {
    'X-CNSAMC-FCM-TOKEN': localStorage.getItem('fcmToken') || '',
    'X-CNSAMC-USER-CHANNEL': 'PortalWeb',
  }
}

declare global {
  interface Date {
    toServerTime(): Date
  }
}
let GAP_BETWEEN_SERVER_AND_CLIENT = 0
Date.prototype.toServerTime = function () {
  return new Date(this.getTime() - GAP_BETWEEN_SERVER_AND_CLIENT)
}
let SERVER_TIME = new Date().toServerTime().getTime()
export const setServerTime = function (time) {
  const currentClientDate = new Date().toServerTime()
  SERVER_TIME = time
  GAP_BETWEEN_SERVER_AND_CLIENT = currentClientDate.getTime() - SERVER_TIME
}
